import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Grid, Typography } from '@mui/material';
import ImpactIcon from 'components/StudyDashboard/QCMarkers/ImpactIcon';
import { QCImpactId } from 'interfaces/qcMarkers';
import { map } from 'lodash';
import React from 'react';

interface QcMarkerLegendProps {
  activeImpacts: QCImpactId[];
}

export const QC_RULE_DEPENDENCY_NOTICE = 'Cell-type rules use a flagged or excluded marker';

export const qcMarkerLegendExplains: {
  icon: React.ReactNode;
  description: string;
  impact?: QCImpactId;
}[] = [
  {
    icon: <ImpactIcon qcImpactId={QCImpactId.FLAGGED} />,
    description: QCImpactId.FLAGGED,
    impact: QCImpactId.FLAGGED,
  },
  {
    icon: <ImpactIcon qcImpactId={QCImpactId.EXCLUDE} />,
    description: QCImpactId.EXCLUDE,
    impact: QCImpactId.EXCLUDE,
  },
  {
    icon: <ErrorOutlineIcon fontSize="small" sx={{ mr: 1 }} />,
    description: QC_RULE_DEPENDENCY_NOTICE,
  },
];

const QcMarkerLegend: React.FC<QcMarkerLegendProps> = ({ activeImpacts }) => {
  const explains = qcMarkerLegendExplains.filter((entry) => !entry.impact || activeImpacts.includes(entry.impact));
  if (!activeImpacts.length) return null;
  return (
    <Grid
      container
      spacing={2}
      direction="row"
      justifyContent="flex-start"
      sx={(theme) => ({ padding: theme.spacing(2) })}
    >
      {map(explains, (qcMarkerLegendExplain) => (
        <Grid item key={qcMarkerLegendExplain.description} sx={(theme) => ({ marginRight: theme.spacing(4) })}>
          <Grid container direction="row" alignItems="center">
            <Grid item>{qcMarkerLegendExplain.icon}</Grid>
            <Grid item>
              <Typography>{qcMarkerLegendExplain.description}</Typography>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default QcMarkerLegend;
